import { render, staticRenderFns } from "./FormViewer.vue?vue&type=template&id=b4237090&"
import script from "./FormViewer.vue?vue&type=script&lang=js&"
export * from "./FormViewer.vue?vue&type=script&lang=js&"
import style0 from "./FormViewer.vue?vue&type=style&index=0&id=b4237090&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports